/**
 * Identity of one (message, locale) translation request, shared by every
 * Messages surface that tracks such requests: the detail page's Translations
 * panel (in-flight and error state per request) and the Messages page's
 * resolution matrix (which cells are ticked).
 *
 * Scoping by BOTH the message and the locale, never the locale alone, is the
 * point: the `/messages/:id` route does not remount when navigating between
 * sibling locales, so a promise started on message A settling after the user
 * has moved to message B must not clear B's state for the same locale code.
 */

/** The separator is safe because a message id is a UUID and a locale is BCP-47-ish — neither can contain a colon. */
const SEPARATOR = ':'

export function buildRequestKey(messageId: string, locale: string): string {
	return `${messageId}${SEPARATOR}${locale}`
}

/** Inverse of {@link buildRequestKey}. Splits at the FIRST separator so a locale is recovered whole. */
export function parseRequestKey(key: string): { messageId: string; locale: string } {
	const at = key.indexOf(SEPARATOR)
	if (at < 0) return { messageId: key, locale: '' }
	return { messageId: key.slice(0, at), locale: key.slice(at + 1) }
}
